import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class DeleteKundorderradCommand extends BasicCommand<DeleteKundorderradCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<DeleteKundorderradCommand>;
    kundorderradId: number;
    kundorderId: number;

    constructor(kundorderradId: number, kundorderId: number) {
        super("DeleteKundorderradCommand", "kundorderrad", CommandType.Delete);
        this.kundorderradId = kundorderradId;
        this.kundorderId = kundorderId;
    }
}
